import { render, staticRenderFns } from "./global_modals.vue?vue&type=template&id=166071b1&"
import script from "./global_modals.vue?vue&type=script&lang=js&"
export * from "./global_modals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports